import React from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import PageHeader from "../../../components/PageHeader";
import {apiCall} from "../../../helpers/MainHelper";
import ReactLoading from "react-loading";

class WarehouseStockReport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            warehouses: [],
            filters: {
                warehouse_id: ''
            },
            reportData: [],
            hasGenerated: false
        }
    }

    componentDidMount() {
        this.fetchWarehouses();
    }

    fetchWarehouses = async () => {
        try {
            const response = await apiCall('business/stock/warehouse/select-list','get');
            this.setState({warehouses: response.data || []});
        } catch (e) {
            console.error(e);
        }
    }

    handleFilterChange = (e) => {
        const {name, value} = e.target;
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                [name]: value
            }
        }));
    }

    generateReport = async () => {
        if(!this.state.filters.warehouse_id) {
            alert('Lütfen bir depo seçiniz!');
            return;
        }

        this.setState({loading: true});
        try {
            const response = await apiCall('business/stock/report/warehouse-stock','post', JSON.stringify(this.state.filters), {
                'Content-Type': 'application/json'
            });
            if(response.status === 'success') {
                this.setState({
                    reportData: response.data || [],
                    hasGenerated: true
                });
            }
        } catch (e) {
            console.error(e);
            this.setState({hasGenerated: true});
        }
        this.setState({loading: false});
    }

    formatCurrency = (amount) => {
        return new Intl.NumberFormat('tr-TR', {
            style: 'currency',
            currency: 'TRY'
        }).format(amount || 0);
    }

    render() {
        const {loading, warehouses, filters, reportData, hasGenerated} = this.state;

        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Depo Bazlı Stok Raporu"
                            Breadcrumb={[
                                { name: "Stok Yönetimi", navigate: "" },
                                { name: "Raporlar", navigate: "" },
                                { name: "Depo Stok Raporu", navigate: "" },
                            ]}
                        />

                        {/* Filtreler */}
                        <div className="row clearfix">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="header">
                                        <h2>Filtreler</h2>
                                    </div>
                                    <div className="body">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Depo *</label>
                                                    <select
                                                        name="warehouse_id"
                                                        className="form-control"
                                                        value={filters.warehouse_id}
                                                        onChange={this.handleFilterChange}
                                                        required
                                                    >
                                                        <option value="">Depo Seçiniz</option>
                                                        {warehouses.map(warehouse => (
                                                            <option key={warehouse.id} value={warehouse.id}>
                                                                {warehouse.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>&nbsp;</label>
                                                    <button
                                                        className="btn btn-primary btn-block"
                                                        onClick={this.generateReport}
                                                        disabled={loading}
                                                        style={{textAlign: "-webkit-center"}}>

                                                        {loading ? <ReactLoading type="spin" width={'20px'} height={'20px'} /> : 'Rapor Oluştur'}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Rapor Sonuçları */}
                        {hasGenerated && reportData.length > 0 && (
                            <div className="row clearfix">
                                <div className="col-lg-12">
                                    <div className="card">
                                        <div className="header">
                                            <h2>Depo Stok Durumu <small>{reportData.length} ürün</small></h2>
                                        </div>
                                        <div className="body">
                                            <div className="table-responsive">
                                                <table className="table table-hover table-vcenter mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th>Stok Kalemi</th>
                                                            <th>SKU</th>
                                                            <th>Kategori</th>
                                                            <th className="text-right">Toplam Miktar</th>
                                                            <th className="text-right">Rezerve</th>
                                                            <th className="text-right">Kullanılabilir</th>
                                                            <th className="text-right">Birim Fiyat</th>
                                                            <th className="text-right">Toplam Değer</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {reportData.map((item, index) => (
                                                            <tr key={index}>
                                                                <td><strong>{item.stock_item_name}</strong></td>
                                                                <td><small>{item.sku || '-'}</small></td>
                                                                <td><small>{item.category_name || '-'}</small></td>
                                                                <td className="text-right">{Math.round(item.quantity || 0)}</td>
                                                                <td className="text-right text-warning">{Math.round(item.reserved_quantity || 0)}</td>
                                                                <td className="text-right text-success">
                                                                    <strong>{Math.round(item.available_quantity || 0)}</strong>
                                                                </td>
                                                                <td className="text-right"><small>{this.formatCurrency(item.unit_price)}</small></td>
                                                                <td className="text-right text-primary">
                                                                    <strong>{this.formatCurrency(item.total_value)}</strong>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                    <tfoot>
                                                        <tr className="bg-light">
                                                            <td colSpan="7" className="text-right"><strong>TOPLAM DEĞER:</strong></td>
                                                            <td className="text-right text-primary">
                                                                <strong>
                                                                    {this.formatCurrency(
                                                                        reportData.reduce((sum, item) => sum + (parseFloat(item.total_value) || 0), 0)
                                                                    )}
                                                                </strong>
                                                            </td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Veri Yok Uyarısı */}
                        {!loading && hasGenerated && reportData.length === 0 && (
                            <div className="row clearfix">
                                <div className="col-lg-12">
                                    <div className="card">
                                        <div className="body">
                                            <div className="alert alert-warning text-center mb-0">
                                                <i className="icon-info" style={{fontSize: '48px', display: 'block', marginBottom: '15px'}}></i>
                                                <h4>Veri Bulunamadı</h4>
                                                <p>Seçili depoda herhangi bir stok kalemi bulunamadı.</p>
                                                <small className="text-muted">Farklı bir depo seçerek tekrar deneyebilirsiniz.</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* İlk Yükleme Mesajı */}
                        {!loading && !hasGenerated && (
                            <div className="row clearfix">
                                <div className="col-lg-12">
                                    <div className="card">
                                        <div className="body">
                                            <div className="alert alert-info text-center mb-0">
                                                <i className="icon-layers" style={{fontSize: '48px', display: 'block', marginBottom: '15px', color: '#17a2b8'}}></i>
                                                <h4>Rapor Oluşturun</h4>
                                                <p>Depo stok durumunu görüntülemek için bir depo seçin ve "Rapor Oluştur" butonuna tıklayın.</p>
                                                <small className="text-muted">Seçili deponun tüm stok kalemleri detaylı olarak listelenecektir.</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({stockReducer}) => ({});

export default withRouter(connect(mapStateToProps, {})(WarehouseStockReport));




